import React from 'react'

import styles from './styles.module.scss'

interface CtaBannerProps {
  headline: string
  subheadline: string
  backgroundImage: string
  href?: string
  onClick?: () => void
}

const CtaBanner: React.FC<CtaBannerProps> = ({
  headline,
  subheadline,
  backgroundImage,
  href = '#contact-form',
  onClick,
}) => {
  return (
    <section className={styles.banner} style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className={styles.overlay}>
        <a href={href} className={styles.link} onClick={onClick}>
          <span className={styles.headline}>{headline}</span>
          <span className={styles.subheadline}>{subheadline}</span>
        </a>
      </div>
    </section>
  )
}

export default CtaBanner
